import React, { Component } from 'react';
import { actions, Control, Errors } from 'react-redux-form';
import PropTypes from 'prop-types';
import { Button, ControlLabel, FormControl, FormGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { validators } from '../../../../utils/validators';

class RequiredInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      required: false,
      isEmail: false,
      isPositive: false
    };
  }

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  onBlur = () => {
    if (typeof this.props.onBlur === 'function') {
      this.props.onBlur();
    }
  }

  changeAction = (model, value) => (dispatch) => {
    dispatch(actions.change(model, value));
    dispatch(actions.resetValidity(model));
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(value);
    }
  };

  getValidationState = () => {
    const fields = ['required', 'isEmail', 'isPositive'];
    const validationArray = fields.map((field) => {
      if (this.state[field] === 'error') {
        return 'error';
      }
      return null;
    });

    if (validationArray.includes('error')) {
      return 'error';
    } else if (validationArray.includes('warning')) {
      return 'warning';
    } else if (validationArray.includes('success')) {
      return 'success';
    }

    return null;
  }

  render() {
    const {
      model, label, inputType, controlId, errorLabel, tooltip, debounce, groupClassName, additionalValidators, positive, zeroAllowed,
      ...props
    } = this.props;

    return (
      <FormGroup className={groupClassName} controlId={controlId} validationState={this.getValidationState()}>
        {label && (
          <ControlLabel>
            {label}
            *
          </ControlLabel>
        )}
        {
          tooltip && (
            <OverlayTrigger
              overlay={(
                <Tooltip className="tooltip" id="tooltip">
                  {tooltip}
                </Tooltip>
              )}
              placement="left"
            >
              <Button className="tip pull-right" tabIndex="-1">
                ?
              </Button>
            </OverlayTrigger>
          )
        }

        <Control
          onBlur={this.onBlur}
          changeAction={this.changeAction}
          component={FormControl}
          debounce={debounce || 0}
          model={model}
          type={inputType}
          validators={{
            ...additionalValidators,
            isEmail: model === '.email' ? validators.isEmail(this.updateErrors, 'isEmail') : () => true,
            required: zeroAllowed ? validators.requiredWithZero(this.updateErrors, 'required')
             : validators.required(this.updateErrors, 'required'),
            isPositive: positive ? validators.isPositive(this.updateErrors, 'isPositive') : () => true,
          }}
          {...props}
          onChange={false}
        />

        <Errors
          className="errors"
          messages={{
            required: 'This field is required',
            patternMismatch: 'Value does not match the required pattern',
            isEmail: 'Value is not a valid email',
            isPositive: 'Value must be positive'
          }}
          model={model}
          show={{
            touched: true,
            focus: false
          }}
        />
      </FormGroup>
    );
  }
}

RequiredInput.propTypes = {
  model: PropTypes.string.isRequired,
  label: PropTypes.string,
  inputType: PropTypes.string,
  groupClassName: PropTypes.string,
  pattern: PropTypes.string,
  controlId: PropTypes.string,
  placeholder: PropTypes.string,
  errorLabel: PropTypes.string,
  tooltip: PropTypes.string,
  debounce: PropTypes.number,
  additionalValidators: PropTypes.object,
  zeroAllowed: PropTypes.bool
};

RequiredInput.defaultProps = {
  inputType: 'text',
  groupClassName: '',
  controlId: Math.random()
    .toString(16)
    .substring(2),
  errorLabel: 'error',
};

export default RequiredInput;



// WEBPACK FOOTER //
// ./src/components/common/form/elements/required-input.jsx